const mobiles = [
  {
    image: "images/product1.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    image: "images/product2.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    image: "images/product3.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    image: "images/product4.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    image: "images/product1.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    image: "images/product6.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    image: "images/product7.webp",
    category: "Mobile",
    name: "Samsung Galaxy S21",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
];

export default mobiles;
